import { useTranslation } from 'react-i18next';

import { ServiceContractRythm } from '@work4all/models/lib/Enums/ServiceContractRythm.enum';

export const ServiceContractRythmCell = ({
  value,
}: {
  value: ServiceContractRythm;
}) => {
  const { t } = useTranslation();

  return <div>{t(`SERVICECONTRACT.RYTHMSTATUSES.${value}`)}</div>;
};
